var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { plainToClass } from 'class-transformer';
import { Clinic, Patient } from 'models';
import Model from 'models/Model';
import ServiceOrderItem from './ServiceOrderItem';
var ServiceOrder = /** @class */ (function (_super) {
    __extends(ServiceOrder, _super);
    function ServiceOrder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ServiceOrder.prototype.getId = function () {
        return Number(this.id);
    };
    ServiceOrder.prototype.getPatientId = function () {
        return Number(this.patient_id);
    };
    ServiceOrder.prototype.setPatientId = function (patientId) {
        this.patient_id = patientId;
    };
    ServiceOrder.prototype.getClinicId = function () {
        return Number(this.clinic_id);
    };
    ServiceOrder.prototype.setClinicId = function (clinicId) {
        this.clinic_id = clinicId;
    };
    ServiceOrder.prototype.getPatientJourneyId = function () {
        return this.patient_journey_id != null ? Number(this.patient_journey_id) : undefined;
    };
    ServiceOrder.prototype.setPatientJourneyId = function (patientJourneyId) {
        this.patient_journey_id = patientJourneyId;
    };
    ServiceOrder.prototype.getReceptionDeskId = function () {
        return this.reception_desk_id != null ? Number(this.reception_desk_id) : undefined;
    };
    ServiceOrder.prototype.setReceptionDeskId = function (receptionDeskId) {
        this.reception_desk_id = receptionDeskId;
    };
    ServiceOrder.prototype.getStatus = function () {
        return this.status;
    };
    ServiceOrder.prototype.setStatus = function (status) {
        this.status = status;
    };
    ServiceOrder.prototype.getNotes = function () {
        return this.notes || '';
    };
    ServiceOrder.prototype.setNotes = function (notes) {
        this.notes = notes;
    };
    ServiceOrder.prototype.getTotalPrice = function () {
        return Number(this.total_price || 0);
    };
    ServiceOrder.prototype.getPatient = function () {
        return this.patient ? plainToClass(Patient, this.patient) : undefined;
    };
    ServiceOrder.prototype.getPatientName = function () {
        var _a;
        return ((_a = this.getPatient()) === null || _a === void 0 ? void 0 : _a.getName()) || String(this.getPatientId() || '—');
    };
    ServiceOrder.prototype.getClinic = function () {
        return this.clinic ? plainToClass(Clinic, this.clinic) : undefined;
    };
    ServiceOrder.prototype.getClinicName = function () {
        var _a;
        return ((_a = this.getClinic()) === null || _a === void 0 ? void 0 : _a.getName()) || String(this.getClinicId() || '—');
    };
    ServiceOrder.prototype.getItems = function () {
        return plainToClass(ServiceOrderItem, (this.service_order_items || []));
    };
    ServiceOrder.prototype.setItems = function (items) {
        this.service_order_items = items;
    };
    ServiceOrder.prototype.isCancelled = function () {
        return this.status === 'cancelled';
    };
    return ServiceOrder;
}(Model));
export default ServiceOrder;
